import React from 'react';
import { Field, reduxForm } from 'redux-form';
import i18n from "i18next";
import { SelectField } from 'redux-form-material-ui';
import MenuItem from 'material-ui/MenuItem'
import RaisedButton from 'material-ui/RaisedButton';
import styles from '../../../styles/styles'
import {renderTextField} from "../../../services/form";
import withTranslation from "../../../hoc/withTranslation";

const validate = values => {
    const errors = {};
    ['message'].forEach(field => {
        if (!values[field]) {
            errors[field] = i18n.t('generic.required');
        }
    });
    return errors;
};

const PushForm = (props) => {
    const { handleSubmit, pristine, reset, submitting, groups, sounds } = props;
    let soundItems = sounds.map((sound, index) => {
        return <MenuItem
            key={sound.name}
            value={sound.name}
            primaryText={sound.name}
        />
    });

    let groupItems = groups.map((group, index) => {
        return <MenuItem
            key={group.name}
            value={group.name}
            primaryText={group.name}
        />
    });

    let langItems = ['fr', 'en'].map((group, index) => {
        return <MenuItem
            key={group}
            value={group}
            primaryText={group}
        />
    });
    return (
        <form onSubmit={handleSubmit}>
            <div>
                <Field id="message" name="message" component={renderTextField} label={props.t('generic.message')} fullWidth={true}/>
                <Field
                    id="langs"
                    name="langs"
                    component={SelectField}
                    multiple={true}
                    floatingLabelText={props.t('generic.lang_plural')}
                    hintText={props.t('generic.lang_plural')}
                    fullWidth={true}
                >
                    {langItems}
                </Field>
                <Field
                    id="groups"
                    name="groups"
                    component={SelectField}
                    multiple={true}
                    floatingLabelText={props.t('module.push.groups')}
                    hintText={props.t('module.push.groups')}
                    fullWidth={true}
                >
                    {groupItems}
                </Field>
                <Field
                    id="sound"
                    name="sound"
                    component={SelectField}
                    multiple={false}
                    floatingLabelText={props.t('module.push.sound')}
                    hintText={props.t('module.push.sound')}
                    fullWidth={true}
                >
                    {soundItems}
                </Field>
            </div>
            <div style={styles.formButtons}>
                <RaisedButton
                    style={styles.formButton}
                    label={props.t('generic.submit')}
                    disabled={pristine || submitting}
                    type="submit"
                    primary={true}
                />
                <RaisedButton
                    style={styles.formButton}
                    label={props.t('generic.reset')}
                    type="button"
                    disabled={pristine || submitting}
                    onClick={reset}
                />
            </div>
        </form>
    );
};

export default reduxForm({
    form: 'editPush',
    validate
})(withTranslation(PushForm));



// WEBPACK FOOTER //
// src/components/push/PushForm/PushForm.js